import React, { Component } from "react";
import { TEXTS } from "../constants/texts";

class FinalScreen extends Component {
  render() {
    return (
      <div className="App finalscreen">
        <div className="box-content">
          <header className="FinalScreen message">{this.props.message}</header>
          <button
            className="btn-continue"
            onClick={() => window.location.reload()}
          >
            {TEXTS.buttons.again}
          </button>
        </div>
      </div>
    );
  }
}

export default FinalScreen;
